function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e];
    for (var r in t)
        ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
} return n; }, _extends.apply(null, arguments); }
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { Snackbar } from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import React, { useEffect } from 'react';
import { useToastContext } from './ToastContext';
var handleErrorModal = function handleErrorModal(open, desc) {
    console.log(open, desc); // Added to fix lint, Will be overridden.
};
var Alert = /*#__PURE__*/ React.forwardRef(function Alert(props, ref) {
    return /*#__PURE__*/ React.createElement(MuiAlert, _extends({
        elevation: 6,
        ref: ref,
        variant: "filled"
    }, props));
});
var Toast = function Toast() {
    var _useToastContext = useToastContext(), message = _useToastContext.message, open = _useToastContext.open, setToastState = _useToastContext.setToastState, severityValue = _useToastContext.severityValue, setMessage = _useToastContext.setMessage, setSeverityValue = _useToastContext.setSeverityValue;
    handleErrorModal = function handleErrorModal(open, desc) {
        setMessage(desc);
        setSeverityValue('error');
        setToastState(open);
    };
    useEffect(function () {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, [open]);
    return /*#__PURE__*/ React.createElement("div", {
        className: "toast-container"
    }, severityValue === 'error' ? /*#__PURE__*/ React.createElement(Snackbar, {
        open: open,
        autoHideDuration: 3000,
        anchorOrigin: {
            vertical: 'top',
            horizontal: 'center'
        },
        onClose: function onClose() {
            return setToastState(false);
        },
        style: {
            width: '100%'
        },
        sx: {
            p: 0,
            m: 0,
            top: '20px',
            left: 0,
            mt: '-20px'
        }
    }, /*#__PURE__*/ React.createElement(Alert, {
        onClose: function onClose() {
            return setToastState(false);
        },
        severity: "error",
        sx: {
            width: '-webkit-fill-available',
            background: '#FBEAEA',
            color: '#D32F2F'
        }
    }, message)) : /*#__PURE__*/ React.createElement(Snackbar, {
        open: open,
        autoHideDuration: 10000,
        anchorOrigin: {
            vertical: 'top',
            horizontal: 'center'
        },
        onClose: function onClose() {
            return setToastState(false);
        },
        style: {
            width: '100%'
        },
        sx: {
            p: 0,
            m: 0,
            top: '20px',
            left: 0
        }
    }, /*#__PURE__*/ React.createElement(Alert, {
        iconMapping: {
            success: /*#__PURE__*/ React.createElement(CheckCircleOutlineIcon, {
                fontSize: "inherit"
            })
        },
        onClose: function onClose() {
            return setToastState(false);
        },
        severity: "success",
        sx: {
            width: '-webkit-fill-available',
            background: '#EAF2EA',
            color: '#26890D',
            mt: '35px'
        }
    }, message)));
};
export { handleErrorModal };
export default Toast;
